import CSS from 'csstype';

 
export const grayheader:CSS.Properties = {
    backgroundColor:"rgba(248, 249, 250,1)",
};

export const primaryheader:CSS.Properties = {
    backgroundColor:"rgba(149,46,66,1)",
};

export const cardmargin:CSS.Properties = {
   marginTop:"1vh",
   marginBottom:"1vh",
};
